import React from 'react';
import { render } from 'react-dom';
//components
import App from './app';
//react-router-dom
import { BrowserRouter } from 'react-router-dom';
//react-redux
import { Provider } from 'react-redux';
//store
import { store } from './redux/store';

render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
